const Saetze = require('./saetze.js');
import {formatPrice,checkAusbildung,zeitmodell} from "./logic";

class Kinder {

    /**
     *
     * @param dies
     * @param anz_kinder
     * @param ausbildung
     * @param alleinerziehend
     */
    constructor(dies,
                anz_kinder = 0,
                ausbildung = '',
                alleinerziehend = false) {
        this.dies = dies;
        this.anz_kinder = anz_kinder;
        this.ausbildung = ausbildung;
        this.alleinerziehend = alleinerziehend;
        this.kinderbetreuungbafog = Saetze.kinderbetreuungbafog;
        this.kinderbetreuungmeister = Saetze.saetze.aufstiegsbafoeg.kindergeld;
        this.kindergeld_alleinerziehend_meister = Saetze.kinderbetreuungmeister;
        this.FREIBETRAG_KIND = Saetze.FREIBETRAG_KIND;
        this.FREIBETRAG_VERMOEGEN_KIND = Saetze.FREIBETRAG_VERMOEGEN_KIND;
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        //console.log("nullen kinder")
        return formatPrice(0);
    }

    set kind_anzahl($this){
        let kind_zahl = 0
        this.ausbildung_setzen = $this
        if(kinder_vorhanden($this)){
            if(this.ausbildung==='meister'){
                // Aufstiegsbafäg
                if($this.el$('Kinderm.anz_kinder_meister')){
                    // Anzahl Kinder festlegen
                    kind_zahl = $this.el$('Kinderm.anz_kinder_meister').value
                    // festlegen, ob alleinerziehend
                    this.alleinerziehend_setzen = $this
                }
            }else if(this.ausbildung==='student' || this.ausbildung==='schuelermit' || this.ausbildung==='schuelerohne'){
                // Schüler / Studenten
                if($this.el$('Kinder.anz_kinder')){
                    // Anzahl Kinder festlegen
                    kind_zahl = $this.el$('Kinder.anz_kinder').value
                }
            }
        }
        this.anz_kinder = kind_zahl;
    }

    /**
     * Ausbildungsart festlegen
     * @param $this
     */
    set ausbildung_setzen($this){
        this.ausbildung = checkAusbildung($this)
    }

    /**
     * Setzen, ob Meister alleinerziehend ist
     * @param $this
     */
    set alleinerziehend_setzen($this){
        let allein = false
        if(checkAusbildung($this)==='meister'&&kinder_vorhanden($this)&&$this.el$('Kinderm.alleine_meister')){
            allein = ($this.el$('Kinderm.alleine_meister').value === 'ja')
        }
        this.alleinerziehend = allein
    }

    get kinder_freibetrag_vermoegen(){
        return 0
    }

    get kinder_anzahl(){
        this.kind_anzahl = this.dies
        return this.anz_kinder
    }

    get kinderzuschlag(){
        return this.berechneKinderZU()
    }
    berechneKinderZU(){
        let ki_ergebnis = 0;
        this.ausbildung_setzen = this.dies
        this.alleinerziehend_setzen = this.dies
        //console.log('Ausbildung: '+this.ausbildung)
        switch (this.ausbildung) {
            case 'schuelermit':
                //console.log('schuelermit mit Kind')
            case 'schuelerohne':
                //console.log('schuelerohne mit Kind')
            case 'student':
                //console.log('Student mit Kind')
                ki_ergebnis = (this.kinder_anzahl * this.kinderbetreuungbafog)
                break;
            case 'meister':
                console.log('Meister mit Kind')
                if(this.alleinerziehend){
                    if(!zeitmodell(this.dies)){
                        // alleinerziehend und teilzeit, nur Zuschlag 150€
                        ki_ergebnis = (this.kinder_anzahl * this.kindergeld_alleinerziehend_meister)
                    }else{
                        //Alleinerziehender Meister Kinderzuschlag 235 + 150 alleinerziehend
                        ki_ergebnis = (this.kinder_anzahl * (this.kinderbetreuungmeister+this.kindergeld_alleinerziehend_meister))
                    }
                }else{
                    // nicht alleinerziehend und Vollzeit, 235€
                    ki_ergebnis = (this.kinder_anzahl * this.kinderbetreuungmeister)
                }
                break;
            default:
                //console.log('default mit Kind')
                break;
        }
        return formatPrice(ki_ergebnis);
    }

}

function kinderzuschlagBerechnen($this, aus = false){
    const ki = new Kinder($this);
    if(aus){
        ki.alleinerziehend_setzen = $this
        if(!zeitmodell($this)&&checkAusbildung($this)==='meister'&&kinder_vorhanden($this)&&ki.alleinerziehend){
            // Teilzeit, Meister, Kinder vorhanden + alleinerziehend -> einfachen Kinderzuschlag 150€
            $this.el$('results.kinderzuschlag').value = ki.kinderzuschlag
        }else{
            // alles nullen
            $this.el$('results.kinderzuschlag').value = ki.null
            //console.log('Kinderzuschlag null: '+$this.el$('results.kinderzuschlag').value)
        }
    } else {
        if(kinder_vorhanden($this)){
            $this.el$('results.kinderzuschlag').value = ki.kinderzuschlag
        }else{
            $this.el$('results.kinderzuschlag').value = ki.null
        }
    }
}

function get_anz_kinder($this){
    const ki = new Kinder($this);
    return ki.kinder_anzahl
}

function kinder_vorhanden($this){
    if($this.el$('Ausbildung.kind_vorh')){
        if($this.el$('Ausbildung.kind_vorh').value === 'ja'){
            return true
        }
    }
    return false
}

/**
 * Studenten/Schüler BAföG-Abfrage das Alter aus der Config-Sätze in die Frage einsetzen
 * @param $this
 */
function bafoeg_kinder_alter($this){
    // alter bei den Kindern ersetzen
    let kinderfeld = $this.el$('Kinder.anz_kinder').label
    //console.log(kinderfeld)
    $this.el$('Kinder.anz_kinder').label = kinderfeld.replace('&alter&', Saetze.KINDERALTERBIS)
    //console.log($this.el$('Kinder.anz_kinder').label)
}

/**
 * Funktionen exportieren
 */
export {bafoeg_kinder_alter,kinder_vorhanden,get_anz_kinder,kinderzuschlagBerechnen};
